(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_menu-item"] && !Shopify.designMode) return;
  try {
    function initNavItemToggle(root) {
    if (root.dataset.navToggleInitialized === 'true') return;
    root.dataset.navToggleInitialized = 'true';

    const toggle = root.querySelector('[data-nav-item-toggle]');
    const panel = root.querySelector('[data-nav-item-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      root.classList.toggle('nav-item--open', !expanded);
    });

    root.addEventListener('focusout', (event) => {
      if (root.contains(event.relatedTarget)) return;
      toggle.setAttribute('aria-expanded', 'false');
      root.classList.remove('nav-item--open');
    });
  }

  function initAllNavItemToggles() {
    document.querySelectorAll('.nav-item').forEach(initNavItemToggle);
  }

  window.addEventListener('load', initAllNavItemToggles);
  document.addEventListener('shopify:section:load', initAllNavItemToggles);
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.querySelector('[data-nav-item-panel]');
    const toggle = event.target.querySelector('[data-nav-item-toggle]');
    if (panel && toggle) {
      toggle.setAttribute('aria-expanded', 'true');
      event.target.classList.add('nav-item--open');
    }
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    const toggle = event.target.querySelector('[data-nav-item-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      event.target.classList.remove('nav-item--open');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
